import { Loader2 } from "lucide-react";
import { CamposDoCadastro } from "./CamposDoCadastro";
import { useCadastro } from "./use-cadastro";

const aviso = "rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2 text-[12px] leading-relaxed text-zinc-600 dark:border-border dark:bg-muted/30 dark:text-muted-foreground";

/** A aba Dados: o cadastro em cartões por seção, salvo de uma vez. */
export function DadosDoCadastro({ id }: { id: string }) {
  const { detail, values, setValues, podeEditar, vindoDoPerfil, travado, salvar, salvando } = useCadastro({ id });
  if (!detail.data) return null;

  return (
    <div className="space-y-4">
      {vindoDoPerfil && (
        <p className={aviso}>
          <span className="font-semibold text-zinc-800 dark:text-foreground">Parceiro conectado.</span> Nome, documento, contato, CRO e endereço vêm do
          perfil dele e são atualizados por ele — aqui ficam só pra consulta. Continuam seus: e-mail de contato, especialidade, observações e a
          configuração comercial.
        </p>
      )}
      {!podeEditar && <p className={aviso}>Cadastro de parceiro é editado por administradores da organização. Você pode consultar, ativar e desativar.</p>}
      <CamposDoCadastro values={values} setValues={setValues} travado={travado} podeEditar={podeEditar} emCartoes />
      {podeEditar && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={salvar}
            disabled={salvando}
            className="inline-flex h-10 items-center gap-1.5 rounded-md bg-brand-600 px-5 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 disabled:opacity-60"
          >
            {salvando && <Loader2 className="h-4 w-4 animate-spin" />}
            Salvar
          </button>
        </div>
      )}
    </div>
  );
}
